import { render, staticRenderFns } from "./PageCell.vue?vue&type=template&id=356deb5d&"
import script from "./PageCell.vue?vue&type=script&lang=js&"
export * from "./PageCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports